<div class="empty-screen-container">
  <div class="icon-container">
    <nb-icon [icon]="icon" class="giant-icon"></nb-icon>
  </div>
  <h2 class="title">{{ title }}</h2>
  <p class="message">{{ message }}</p>
</div>
